<script>
// import { globalVariablesMixin } from '../../../../Mixins/global'

export default {
  // mixins: [globalVariablesMixin]
}
</script>
<template>
  <nav class="sidebar-navigation">
    <slot name="header"></slot>
    <ul class="menu" v-if="$slots.default">
      <slot></slot>
    </ul>
    <slot name="footer"></slot>
  </nav>
</template>
